/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUserShort
 */
export interface OutputUserShort {
    /**
     * 
     * @type {number}
     * @memberof OutputUserShort
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUserShort
     */
    name: string;
}

/**
 * Check if a given object implements the OutputUserShort interface.
 */
export function instanceOfOutputUserShort(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputUserShortFromJSON(json: any): OutputUserShort {
    return OutputUserShortFromJSONTyped(json, false);
}

export function OutputUserShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUserShort {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputUserShortToJSON(value?: OutputUserShort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

